import styled from "@emotion/styled";
import { LinearProgress, linearProgressClasses } from "@mui/material";
import { COLORS } from "shared/constants/AppEnums";

export const LinearProgressBar = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: COLORS.primary,
    },
}));